module.exports = __webpack_public_path__ + "static/GridLayouts-44a0726ddf5de619e3dcfe19b670168a.png";